import React from 'react';
import { useBoxClasses } from './useBoxClasses';
import { useTheme } from '../../../theme';
import { join } from '../../../utils/className';
/**
 * `Box` is the most abstract component on top of which all other components are built. By default, it renders a `div` element.
 * You can use the `tag` prop to change the element render, just like `as` prop from styled-components.
 *
 * @see https://fe-docs.int.getresponse.com/gr-ui-neo/index.html?path=/docs/layout-box--page
 */
export const Box = React.forwardRef(({ children, tag = 'div', className, marginRight, marginLeft, marginTop, marginBottom, margin, marginX, marginY, paddingRight, paddingLeft, paddingTop, paddingBottom, padding, paddingX, paddingY, minWidth, minHeight, maxWidth, maxHeight, size, width, height, display, borderRight, borderLeft, borderTop, borderBottom, borderRadius, border, borderColor, boxShadow, background, backgroundHovered, color, colorHovered, flexBasis, flexGrow, flexShrink, gridColumnSpan, gridRowSpan, gridArea, overflow, position, top, bottom, left, right, zIndex, ...props }, ref) => {
    const theme = useTheme();
    const classes = useBoxClasses({
        theme,
        display,
        marginRight,
        marginLeft,
        marginTop,
        marginBottom,
        margin,
        marginX,
        marginY,
        paddingRight,
        paddingLeft,
        paddingTop,
        paddingBottom,
        padding,
        paddingX,
        paddingY,
        minWidth,
        minHeight,
        maxWidth,
        maxHeight,
        size,
        width,
        height,
        border,
        borderRight,
        borderLeft,
        borderTop,
        borderBottom,
        borderRadius,
        borderColor,
        background,
        backgroundHovered,
        color,
        colorHovered,
        flexBasis,
        flexGrow,
        flexShrink,
        gridColumnSpan,
        gridRowSpan,
        gridArea,
        boxShadow,
        overflow,
        position,
        top,
        bottom,
        left,
        right,
        zIndex,
    });
    const Tag = tag;
    return (React.createElement(Tag, { ref: ref, className: join(className, classes.box), ...props }, children));
});
